import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import SelectInput from '@repo/ui/select-input'
import Typography from '@repo/ui/typography'
import React from 'react'

import { CurrencyEnum, currencyEnumMapping } from '../../../lib/types/enums/common/currency.enum'

type Props = {
  readonly: boolean
  currency: CurrencyEnum
  onChange?: (currency: CurrencyEnum) => void
}

const TravelExpensesCurrencyInput: React.FC<Props> = ({ readonly, currency, onChange }) => {
  if (readonly) {
    return (
      <Badge
        size="medium"
        borderColor={tailwindColors.grey.light.DEFAULT}
        text={
          <Typography variant="secondary-body">
            <span className="text-grey-lighter">Devise : </span>
            {currencyEnumMapping[currency].label}
          </Typography>
        }
      />
    )
  }
  return (
    <SelectInput
      className="w-52"
      label={'Devise'}
      options={Object.values(CurrencyEnum).map((currency) => ({
        label: currencyEnumMapping[currency].label,
        value: currency
      }))}
      onChange={onChange}
      selectedOption={{ label: currencyEnumMapping[currency].label, value: currency }}
    />
  )
}

export default TravelExpensesCurrencyInput
